import { Directive, effect, inject, input } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';

@Directive({
  selector: '[coreCopyPrefix]',
})
export class PrefixInputDirective {
  private readonly ngControl = inject(NgControl, { optional: true });

  isCopy = input<boolean>(false, { alias: 'coreCopyPrefix' });
  copyPrefix = input<string>('');

  constructor() {
    effect(() => {
      const control = this.ngControl?.control;
      if (!control) return;

      if (this.isCopy()) {
        this.addPrefix(control);
      } else {
        this.removePrefix(control);
      }
    });
  }

  private addPrefix(control: AbstractControl) {
    const prefix = this.copyPrefix();
    const cur = (control.value ?? '').toString().trim();
    if (!cur) {
      control.setValue(prefix);
      return;
    }
    if (!cur.startsWith(`${prefix} `)) {
      control.setValue(`${prefix} ${cur}`);
    }
  }

  private removePrefix(control: AbstractControl) {
    const prefix = this.copyPrefix();
    const cur = (control.value ?? '').toString();
    const prefixWithSpace = `${prefix} `;
    if (cur.startsWith(prefixWithSpace)) {
      control.setValue(cur.slice(prefixWithSpace.length));
    }
  }
}
